module.exports = __webpack_public_path__ + "img/photo-24.8e8eb946.webp";